export const numberWithCommas = (x) => {
  if (!x) return 0;
  return x.toLocaleString('en-IN');
}